/**
 * Serialisation for the Clients list view state. Everything that decides *which* rows are shown
 * lives in the URL query string, so Back from a detail page (and a shared link) restores the list.
 */

export const COMPANY_STATUS_OPTIONS = ['All', 'Active', 'Inactive'];
export const USER_STATUS_OPTIONS = ['All', 'Active', 'Inactive'];
export const ROLE_OPTIONS = ['All', 'Owner', 'User'];
export const SORT_OPTIONS = ['nameAsc', 'nameDesc', 'newest', 'oldest'];
export const PAGE_SIZE_OPTIONS = [20, 50, 100];

export const SORT_LABELS = {
    nameAsc: 'Company A–Z',
    nameDesc: 'Company Z–A',
    newest: 'Created: newest',
    oldest: 'Created: oldest',
};

export const DEFAULT_QUERY = {
    search: '',
    companyStatus: 'All',
    userStatus: 'All',
    role: 'All',
    sort: 'nameAsc',
    page: 1,
    pageSize: 20,
};

const oneOf = (value, allowed, fallback) => (allowed.includes(value) ? value : fallback);

export const parseQuery = (searchParams) => {
    const pageRaw = parseInt(searchParams.get('page'), 10);
    const pageSizeRaw = parseInt(searchParams.get('pageSize'), 10);
    return {
        search: searchParams.get('search') ?? '',
        companyStatus: oneOf(searchParams.get('companyStatus'), COMPANY_STATUS_OPTIONS, 'All'),
        userStatus: oneOf(searchParams.get('userStatus'), USER_STATUS_OPTIONS, 'All'),
        role: oneOf(searchParams.get('role'), ROLE_OPTIONS, 'All'),
        sort: oneOf(searchParams.get('sort'), SORT_OPTIONS, 'nameAsc'),
        page: Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw : 1,
        pageSize: PAGE_SIZE_OPTIONS.includes(pageSizeRaw) ? pageSizeRaw : 20,
    };
};

/** Only non-default values end up in the URL, so a pristine list has a clean `/clients`. */
export const toSearchParams = (query) => {
    const params = new URLSearchParams();
    if (query.search) params.set('search', query.search);
    if (query.companyStatus !== DEFAULT_QUERY.companyStatus) params.set('companyStatus', query.companyStatus);
    if (query.userStatus !== DEFAULT_QUERY.userStatus) params.set('userStatus', query.userStatus);
    if (query.role !== DEFAULT_QUERY.role) params.set('role', query.role);
    if (query.sort !== DEFAULT_QUERY.sort) params.set('sort', query.sort);
    if (query.page !== 1) params.set('page', String(query.page));
    if (query.pageSize !== DEFAULT_QUERY.pageSize) params.set('pageSize', String(query.pageSize));
    return params;
};

/** Changes to anything except the page number send the user back to page 1. */
export const CHANGES_THAT_RESET_PAGE = ['search', 'companyStatus', 'userStatus', 'role', 'sort', 'pageSize'];
